import { useState } from 'react';
import axios from 'axios';

function InviteUser() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const sendInvitation = async () => {
    try {
      const response = await axios.post('http://localhost:5000/api/inviteuser/invite', { email });
      console.log('Response:', response.data);
      setMessage(`✅  ${response.data.message || 'Invitation sent successfully!'}`);
    } catch (err) {
      setMessage(`❌ Error: ${err.response?.data?.message || err.message}`);
    }
  };

  return (
    <div className="invite-container">
      <h2>Send Invitation</h2>
      <input
        type="email"
        placeholder="Enter user email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <button onClick={sendInvitation}>Send</button>
      {message && <p>{message}</p>}
    </div>
  );
}

export default InviteUser;
